import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  AccountCircle,
  AddBusiness,
  ContactPhone,
  PhoneAndroidOutlined,
  PinDrop,
  Store,
} from "@mui/icons-material";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { callPostApi } from "../../API/ApiCallFunction";
import GradientLoader from "../../CommanComponents/GradientLoader";
import { useEffect } from "react";
import { toast } from "react-toastify";

export default function StoreDialog() {
  const [open, setOpen] = React.useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
   
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [appname, setAppname] = useState(user.store_info.cashi_app_name);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (user?.store_info?.cashi_app_name) {
      // setAppname(user.store_info.cashi_app_name);
    }
  }, [user]);

  //APP name api
  const appNameApi = async () => {
    if (!appname.trim()) {
      toast.warning("App name cannot be empty!");
      return;
    }
    try {
      setLoading(true);
      const storeid = user.store_info.store_id;
      const payload = {
        mod: "STORE_UPDATE",
        data_arr: { store_id: storeid, cashi_app_name: appname },
      };
      const apiResult = await callPostApi("store-update", payload);
      if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
        toast.success("App name updated successfully!");
      } else {
        toast.info("Failed to update app name. Please try again.");
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading && <GradientLoader text="Loading" />}
      <Button
        sx={{
          background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
          px: "7px",
          py: "5px",
          borderRadius: "6px",
          my: "5px",
          color: "#fff",
        }}
        onClick={handleClickOpen}
      >
        {" "}
        <Store />
        {user.store_info?.store_name?.length > 19
          ? user.store_info.store_name.substring(0, 19) + "..."
          : user.store_info?.store_name}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContent id="alert-dialog-description">
            <Grid container spacing={2}>
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 12 }}
                sx={{ textAlign: "right" }}
              >
                <img
                  src={user.store_info.store_image}
                  alt="Store image"
                  style={{ width: "60px", marginLeft: "4px" }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Store Name"
                  value={user.store_info.store_name}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ style: { color: "#888" } }}
                  style={{ width: "100%" }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <Store sx={{ color: "#1A73E8" }} />{" "}
                        </InputAdornment>
                      ),
                      style: {
                        color: "#000",
                        fontWeight: 500,
                        pointerEvents: "none",
                      },
                    },
                  }}
                  variant="standard"
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Store Address"
                  style={{ width: "100%" }}
                  value={`${user.store_info.area_name}, ${user.store_info.city_name}, ${user.store_info.state_name} `}
                  multiline
                  maxRows={2}
                  InputProps={{ readOnly: true }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <PinDrop sx={{ color: "#1A73E8" }} />
                        </InputAdornment>
                      ),
                      style: {
                        color: "#000",
                        fontWeight: 500,
                        pointerEvents: "none",
                      },
                    },
                  }}
                  variant="standard"
                  InputLabelProps={{ style: { color: "#888" } }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Contact Name"
                  value={user.store_info.owner_name}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ style: { color: "#888" } }}
                  style={{ width: "100%" }}
                  variant="standard"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <AccountCircle sx={{ color: "#1A73E8" }} />
                        </InputAdornment>
                      ),
                      style: {
                        color: "#000",
                        fontWeight: 500,
                        pointerEvents: "none",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Contact Number"
                  value={user.store_info.contact_mobile}
                  style={{ width: "100%" }}
                  variant="standard"
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{
                    style: { color: "#888", pointerEvents: "none" },
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <ContactPhone sx={{ color: "#1A73E8" }} />
                        </InputAdornment>
                      ),
                    },
                    style: {
                      color: "#000",
                      fontWeight: 500,
                      pointerEvents: "none",
                    },
                  }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                <TextField
                  id="input-with-icon-textfield"
                  label="App Name"
                  value={appname}
                  style={{ width: "100%" }}
                  onChange={(e) => setAppname(e.target.value)}
                  variant="standard"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <PhoneAndroidOutlined sx={{ color: "#1A73E8" }} />
                        </InputAdornment>
                      ),
                    },
                    style: { color: "#000", fontWeight: 500 },
                  }}
                />
              </Grid>

              <Grid
                item
                size={{ xs: 12, sm: 12, md: 6 }}
                sx={{ display: "flex", alignItems: "end" }}
              >
                {user.store_info.cashi_app_name === "" ? (
                  <Button
                    variant="contained"
                    sx={{
                      background: "linear-gradient(195deg, #66BB6A, #43A047)",
                      color: "#fff",
                    }}
                    onClick={() => appNameApi()}
                  >
                    {" "}
                    Update App Name
                  </Button>
                ) : (
                  ""
                )}
              </Grid>

              <Grid
                item
                size={{ xs: 12, sm: 12, md: 12 }}
                className="d-flex justify-content-center align-items-center mt-9"
              >
                <Button
                  onClick={handleClose}
                  sx={{
                    background: "linear-gradient(195deg, #42424a, #191919)",
                    color: "#fff",
                    px: 2,
                    mx: 1,
                  }}
                >
                  Close
                </Button>
                <a
                  href="https://play.google.com/store/apps/details?id=com.loyalty.cashi&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    sx={{
                      background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
                      color: "#fff",
                      px: 1,
                    }}
                  >
                    <AddBusiness /> Manage Stores
                  </Button>
                  
              
                </a>
                   
              </Grid>
            </Grid>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
